import $ from 'jquery';
import {
  initContestCustomFields,
  removeFieldVariantHandler
} from './custom-fields';
import {initWorkContentWysiwyg, initWysiwyg} from './wysiwyg';
import {initAnyFileUpload, initVideosUpload, initAudiosUpload, initDocumentsUpload, initImagesUploadCropper} from '../cabinet/upload';
import {showFormResponse} from "../common/json-response";
import initDeleteFieldVariantFiles from '../cabinet/delete-field-variants-files';
import {showDependsParams} from '../cabinet/show-custom-fields-params';
import { bindWbUploadDropzones } from '../wb-embed-ui';

let statusWrapper;

function initVariant(variantBlock) {
  const removeFieldVariantButton = variantBlock.querySelector('.delete_custom_field_variant');
  removeFieldVariantButton.addEventListener('click', removeFieldVariantHandler);
}

function addFieldVariantHandler(e) {
  e.preventDefault();
  const button = e.target;
  const fieldUuid   = button.getAttribute('data-custom-field-uuid');
  const fieldFormat = button.getAttribute('data-custom-field-format');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const fieldFormatAttr = '[data-custom-field-format="' + fieldFormat + '"]';

  const variantsBlockSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr + ' .form__list';
  const variantsBlock = document.querySelector(variantsBlockSelector);

  let url = button.getAttribute('data-add-custom-field-variant-url');
  url = url + '?fieldUuid=' + fieldUuid + '&fieldFormat=' + fieldFormat;

  $.ajax({
    type: "GET",
    url: url,
    dataType: 'json',
    success: function (data) {
      if (data.messages) {
        showFormResponse(data);
      } else if (data.html) {
        variantsBlock.insertAdjacentHTML('beforeEnd', data.html);
        const variantBlock = variantsBlock.querySelector('.variant_item:last-child');
        initVariant(variantBlock);
        initContestCustomFields();
        initWorkContentWysiwyg();
        initWysiwyg();
        initAnyFileUpload();
        initVideosUpload();
        initAudiosUpload();
        initDocumentsUpload();
        initImagesUploadCropper();
        bindWbUploadDropzones(variantsBlock);
        initDeleteFieldVariantFiles();
        showDependsParams();

        const fieldParentBlock = variantsBlock.closest('.custom_field_params');
        const useVariantsInput = fieldParentBlock.querySelector('.checkbox_use_variants_score');

        if (useVariantsInput && useVariantsInput.checked) {
          let changeEvent = new Event('change');
          useVariantsInput.dispatchEvent(changeEvent);
        }

        const showAfterRequestElements = fieldParentBlock.querySelectorAll('.show_after_request');

        showAfterRequestElements?.forEach(function (element) {
          if (element.classList.contains('d-none')) {
            element.classList.remove('d-none');
          }
        });

      }
    },
    error: function (data) {
      const statusWrapper = document.querySelector('.action-status-messages');

      if (data.messages) {
        showFormResponse(data);
      } else {
        const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
        const statusMsg = document.createElement('div');
        statusMsg.classList.add(['alert']);
        statusMsg.classList.add(['alert_error']);
        statusMsg.innerHTML = message;
        statusWrapper.appendChild(statusMsg);
      }
    },
  });
}

function initAddNewCustomFieldsVariants() {
  const addCheckboxSelectFieldVariants = document.querySelectorAll('.add_field_variant');
  statusWrapper = document.querySelector('.action-status-messages');

  addCheckboxSelectFieldVariants?.forEach(function (button) {
    button.addEventListener('click', addFieldVariantHandler);
  });
}

export {initAddNewCustomFieldsVariants, addFieldVariantHandler}
